(ns practitest.frontend.issues.events
  (:require [practitest.frontend.subs :as subs]))

(def issues-index-state-key (:issue subs/index-grid-keys))
